import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Mail, Lock, ArrowRight } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../App';
export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const {
    signIn
  } = useAuth();
  const {
    theme
  } = useTheme();
  const isDark = theme === 'dark';
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const {
      error
    } = await signIn(email, password);
    if (error) {
      setError(error.message);
      setLoading(false);
    }
  };
  return <div className={`min-h-screen flex items-center justify-center px-4 transition-colors duration-500 ${isDark ? 'bg-black' : 'bg-white'}`} data-id="element-454">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="w-full max-w-md" data-id="element-455">
        {/* Logo */}
        <div className="text-center mb-12" data-id="element-456">
          <h1 className={`text-4xl font-black tracking-tighter mb-2 ${isDark ? 'text-white' : 'text-black'}`} data-id="element-457">
            Jav.
          </h1>
          <p className="text-sm uppercase tracking-widest font-light" style={{
          color: isDark ? '#999' : '#666'
        }} data-id="element-458">
            Admin Access
          </p>
        </div>

        {/* Login Form */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.2
      }} className={`border rounded-sm p-8 ${isDark ? 'bg-neutral-950 border-white/20' : 'bg-white border-black/20'}`} data-id="element-459">
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-460">
            {/* Email */}
            <div data-id="element-461">
              <label className="block text-sm uppercase tracking-widest font-light mb-2" style={{
              color: isDark ? '#999' : '#666'
            }} data-id="element-462">
                Email
              </label>
              <div className="relative" data-id="element-463">
                <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5" style={{
                color: isDark ? '#666' : '#999'
              }} data-id="element-464" />
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} required className={`w-full pl-12 pr-4 py-3 rounded-sm border transition-colors focus:outline-none ${isDark ? 'bg-black border-white/20 text-white focus:border-white/40' : 'bg-white border-black/20 text-black focus:border-black/40'}`} placeholder="your@email.com" data-id="element-465" />
              </div>
            </div>

            {/* Password */}
            <div data-id="element-466">
              <label className="block text-sm uppercase tracking-widest font-light mb-2" style={{
              color: isDark ? '#999' : '#666'
            }} data-id="element-467">
                Password
              </label>
              <div className="relative" data-id="element-468">
                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5" style={{
                color: isDark ? '#666' : '#999'
              }} data-id="element-469" />
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} required className={`w-full pl-12 pr-4 py-3 rounded-sm border transition-colors focus:outline-none ${isDark ? 'bg-black border-white/20 text-white focus:border-white/40' : 'bg-white border-black/20 text-black focus:border-black/40'}`} placeholder="••••••••" data-id="element-470" />
              </div>
            </div>

            {/* Error Message */}
            {error && <motion.div initial={{
            opacity: 0,
            y: -10
          }} animate={{
            opacity: 1,
            y: 0
          }} className="p-4 rounded-sm bg-red-500/10 border border-red-500/20" data-id="element-471">
                <p className="text-sm text-red-500" data-id="element-472">{error}</p>
              </motion.div>}

            {/* Submit Button */}
            <button type="submit" disabled={loading} className={`w-full py-4 rounded-sm font-bold flex items-center justify-center gap-2 transition-opacity duration-300 hover:opacity-70 disabled:opacity-50 ${isDark ? 'bg-white text-black' : 'bg-black text-white'}`} data-id="element-473">
              {loading ? 'Signing in...' : <>
                  Sign In
                  <ArrowRight className="w-5 h-5" data-id="element-474" />
                </>}
            </button>
          </form>
        </motion.div>

        {/* Footer Note */}
        <p className="text-center text-xs mt-8 uppercase tracking-wider" style={{
        color: isDark ? '#666' : '#999'
      }} data-id="element-475">
          Secure authentication via Supabase
        </p>
      </motion.div>
    </div>;
}